import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=f2dea694&"
import script from "./register-form.ts?vue&type=script&lang=ts&"
export * from "./register-form.ts?vue&type=script&lang=ts&"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=f2dea694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports